export const Bio = {
  name: "Abdulla Al Moin",
  roles: [
    "Web Developer",
    "Researcher",
    "Programmer",

  ],
  description:
    "Proficient in advanced front-end development with core knowledge such as Design Patterns, OOP, and Functional Programming",
  github: "https://github.com/abdullahmoin",
  resume:
    "https://drive.google.com/file/d/1Y5E3n7e0Wyfx8qVydYC2k4Eq_j4vfRQM/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/abdullahmoin/",
  twitter: "/",
  insta: "https://www.instagram.com/m_oi_n/",
  facebook: "https://www.facebook.com/abdullahmoin08/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg",
      },
    ],
  },
  {
    title: "Web CMS",
    skills: [
      {
        name: "WordPress",
        image:
          "https://s.w.org/style/images/about/WordPress-logotype-wmark.png",
      },
      {
        name: "WooCommerce",
        image:
          "https://cdn.worldvectorlogo.com/logos/woocommerce.svg",
      },
      {
        name: "Shopify",
        image:
          "https://freelogopng.com/images/all_img/1655836788shopify-icon-png.png",
      },
      {
        name: "Ruby on Rails",
        image:
          "https://www.svgrepo.com/show/376345/rails.svg",
      },
      {
        name: "Wix",
        image:
          "https://www.nicepng.com/png/full/266-2669280_wix-logo-wix-site-logo-png.png",
      },
      {
        name: "Elementor",
        image:
          "https://elementor.com/wp-content/uploads/2021/10/logo-symbol-red.svg",
      },
      {
        name: "Stripe",
        image:
          "https://images.ctfassets.net/fzn2n1nzq965/HTTOloNPhisV9P4hlMPNA/cacf1bb88b9fc492dfad34378d844280/Stripe_icon_-_square.svg?q=80&w=1082",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "ML & AI Tools",
    skills: [
      {
        name: "Deep Learning",
        image:
          "https://img.freepik.com/premium-vector/brain-logo-template_15146-28.jpg",
      },
      {
        name: "Keras",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Keras_logo.svg/512px-Keras_logo.svg.png",
      },
      {
        name: "GPT 4",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/GPT-4.png/600px-GPT-4.png?20230403171640",
      },
      {
        name: "Midjourney",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Midjourney_Emblem.png/600px-Midjourney_Emblem.png",
      },
      {
        name: "Stable Diffusion",
        image:
          "https://ai-finder.fra1.cdn.digitaloceanspaces.com/logos%2FStableDiffusion.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      {
        name: "Adobe XD",
        image:
          "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://scontent.fdac5-1.fna.fbcdn.net/v/t39.30808-6/278022569_405211754939230_2993494317386342567_n.png?_nc_cat=109&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=Kss69loWpHsAX9MRMAA&_nc_ht=scontent.fdac5-1.fna&oh=00_AfAbnUx19iMKNwxyJGKVs-bV-ekuvqsJ3Hm5ghJBRFk1DA&oe=65DF3EC2",
    role: "Web Developer",
    company: "Quadque Technologies Limited Bangladesh",
    date: "December 2023 - Present",
    desc: "Develop responsive website (Frontend), WordPress Functional, customize themes, WordPress theme, develop plugins. eCommerce Store develop, LMS Systems, RTO Institutes, SEO, Web Security. Develop Shopify, Wix stores.",
    skills: [
      "JavaScript",
      "Bootstrap",
      "CMS",
      "WordPress",
      "WooCommerce",
      "Php",
      "My SQL",
      "jQuery",
      "Elementor",
      "Componets",
      "Payment Gateway",
      "Ajax",
    ],
    doc: "",
  },
  {
    id: 0,
    img: "https://assets-global.website-files.com/603fea6471d9d8559d077603/6092b7514135708162a4be92_Favicon%20256.png",
    role: "Web & WordPress Developer",
    company: "Upwork | Fiverr",
    date: "February 2021 - Present",
    desc: "Developed responsive website (Frontend), customize themes, WordPress theme, develop plugins. eCommerce Store develop, SEO, Web Security. Develop Shopify, Wix stores.",
    skills: [
      "JavaScript",
      "Bootstrap",
      "WordPress",
      "WooCommerce",
      "Shopify",
      "Ruby & Rails",
      "Payment Gateway",
      "Ajax",
    ],
    doc: "",
  },
  {
    id: 0,
    img: "http://www.mergecreation.net/resource/assets/web/images/logo.png",
    role: "Frontend Engineer",
    company: "Marge Creation Pvt. Ltd.",
    date: "Dec 2020 - Mar 2021",
    desc: "Developed various types of eCommerce website, building up creative multi-vendor e-stores and customizing blog sites based on user friendly environment.",
    skills: [
      "JavaScript",
      "Bootstrap",
      "WordPress",
      "WooCommerce",
      "Shopify",
      "Ruby & Rails",
      "Payment Gateway",
      "Ajax",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://i.pinimg.com/originals/72/2c/57/722c5710002814308caff02ffb294c0d.png",
    role: "Assistant General Secretary",
    company: "DIU CPC",
    date: "Jan 2021 - February 2022",
    desc: "Responsibilities included emailing, blog management and digital promotion, etc. Organize club programs and festivals. Attend several Seminar and Campaign",
    skills: [
      "Mentoring",
      "Grooming",
      "Management",
      "Organizing",
      "Leadership",
      "Public Speacking",
    ],
  },
  {
    id: 2,
    img: "https://yt3.googleusercontent.com/ytc/APkrFKZ3zuTDjNxHSlxr81yX8wqMLr06CoMX_FHEKz1HhA=s900-c-k-c0x00ffffff-no-rj",
    role: "Mentor",
    company: "IC Center",
    date: "July 2019 - March 2020",
    desc: "Taught ICT, Math to students of primary and high school level. Primarily Basic C programming, Concept of DBMS, RDBMS",
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.pinimg.com/originals/72/2c/57/722c5710002814308caff02ffb294c0d.png",
    school: "Daffodil International University",
    date: "September 2023",
    grade: "3.66 CGPA",
    desc: "# JOURNAL-UNDER REVIEW [ECOLOGICAL INFORMATICS]: A deep learning approach to tomato leaf disease detection using EfficientNetB3  # CSE 499: Research & Project [Accepted by Project and Intern Committee, Daffodil International University, August 2023[SP22D326_192-15-2838]: A deep learning approach to detect multiple crop diseases using inceptionv3",
    desc: "# JOURNAL-UNDER REVIEW [ECOLOGICAL INFORMATICS]: A deep learning approach to tomato leaf disease detection using EfficientNetB3 <br> # CSE 499: Research & Project [Accepted by Project and Intern Committee, Daffodil International University, August 2023[SP22D326_192-15-2838]: A deep learning approach to detect multiple crop diseases using inceptionv3",
    degree: "Bachelor of Science - BSc, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcStWyVavuYPstcPzzmGW9JHueirh0PpkMc3VhLl9-pV&s",
    school: "Notre Dame College",
    date: "March 2017",
    grade: "GPA: 4.90",
    desc: "Press Secretary - English Literature Club | Club Festival Organizer 2016 ",
    degree: "Higher Secondary Certificate (HSC)",
  },
  {
    id: 2,
    img: "https://scontent.fdac5-2.fna.fbcdn.net/v/t39.30808-6/301866075_172893415305464_4081963310899424607_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=5f2048&_nc_ohc=qmjoz54MbxgAX9Fs_CT&_nc_ht=scontent.fdac5-2.fna&oh=00_AfAYPz10XVrw9XbgtC8wprtevvhrbJ6mljwwf_kjfIXvlQ&oe=6547D40F",
    school: "Bk High School & College",
    date: "Apr 2015",
    grade: "GPA: 5.00",
    desc: "Ahsania Mission Intra School Debate Competition Award",
    degree: "Secondary School Certificate (SSC)",
  },
];

export const projects = [
  {
    id: 9,
    title: "React Youtube",
    date: "Aug 2022",
    description:
      "React Youtube is a dynamic responsive website where user can play any YouTube videos with Minimalist UI Kits and Lightweight design along with Search and player control functionality",
    image:
      "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
    tags: [
      "React",
      "Google API",
      "PWA",
      "CSS",
      "Husky",
      "Java Script",
      "Redux",
    ],
    category: "web app",
    github: "https://github.com/abdullahmoin/my-react-youtube",
    webapp: "http://moin-youtube.surge.sh/",
  },
  {
    id: 0,
    title: "Deemed Frontend",
    date: "Sep 2022",
    description:
      "A dynamic website to manage eCommerce website, mantain customer with user and admin dashboard features",
    image:
      "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
    tags: ["React Js", "MongoDb", "Node Js", "Redux"],
    category: "web app",
    github: "https://github.com/UitsHabib/demeed-frontend",
    webapp: "",
    member: [
      {
        name: "Abdullah Moin",
        img: "https://avatars.githubusercontent.com/u/68814979?v=4",
        linkedin: "https://www.linkedin.com/in/abdullahmoin/",
        github: "https://github.com/abdullahmoin",
      },
      {
        name: "Habibur Rahman",
        img: "https://avatars.githubusercontent.com/u/52721747?v=4",
        linkedin: "https://www.linkedin.com/in/habibur-r-ahman/",
        github: "https://github.com/UitsHabib",
      },
    ],
  },
  {
    id: 3,
    title: "Buckoid",
    date: "Dec 2021 - Apr 2022",
    description:
      "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    image:
      "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "android app",
    github: "",
    webapp: "",
  },
  
  
  {
    id: 8,
    title: "Face Recognition",
    date: "Jan 2021",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "",
    webapp: "",
  },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
